// Loads appSettings.json to get the key and then initialises segment with said key

var xmlHttp = new XMLHttpRequest();
    
xmlHttp.onreadystatechange = function() { 
    if (xmlHttp.readyState == 4 && (xmlHttp.status === 200 || xmlHttp.status === 304)) {
        var response = xmlHttp.responseText;
        var json = JSON.parse(response);
        var segmentKey = json.segmentKey;
        var userReportKey = json.userReportKey;
        var segmentIntegrityHash = json.segmentIntegrityHash;
        
        //  Add google analytics script for Fleet and Finance
        !function(){
            var analytics=window.analytics=window.analytics||[];
            if(!analytics.initialize)
                if(analytics.invoked)
                    window.console&&console.error&&console.error("Segment snippet included twice.");
                else{
                    analytics.invoked=!0;
                    analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];
                    analytics.factory=function(t){
                        return function(){
                            var e=Array.prototype.slice.call(arguments);
                            e.unshift(t);
                            analytics.push(e);
                            return analytics
                        }
                    };
                    for(var t=0;t<analytics.methods.length;t++){
                        var e=analytics.methods[t];
                        analytics[e]=analytics.factory(e)
                    }
                    analytics.load=function(t){
                        var e=document.createElement("script");
                        e.type="text/javascript";
                        e.async=!0;
                        e.src=("https:"===document.location.protocol?"https://":"http://") + "cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";
                        e.crossOrigin="anonymous";
                        var n=document.getElementsByTagName("script")[0];
                        n.parentNode.insertBefore(e,n)
                        };
                analytics.SNIPPET_VERSION="4.0.0";
                analytics.load(segmentKey);
                analytics.page(); }
        }(); 

        //  Add User Report script for Fleet and Finance
        !function(){
            window._urq = window._urq || [];
            _urq.push(['initSite', userReportKey]);
            (function() {
                var ur = document.createElement('script'); ur.type = 'text/javascript'; ur.async = true;
                ur.src = ('https:' == document.location.protocol ? 'https://cdn.userreport.com/userreport.js' : 'http://cdn.userreport.com/userreport.js');
                var s = document.getElementsByTagName('script')[0]; 
                s.parentNode.insertBefore(ur, s);
            })();
        }();
    }
};

xmlHttp.open("GET", '/appSettings.json', true); 
xmlHttp.send();



// WEBPACK FOOTER //
// src/analytics_and_userReport.js